module.exports = __webpack_public_path__ + "img/212.96ecb931.png";